<div class="why-iquanta-modals why-iquanta-modals-lg">
    <div class="modal" id="BadAcads" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content" *ngIf="showContent">

                <div class="modal-body">
                    <div class="modal-header-card mb-3">
                        <h2 class="d-flex align-items-center">Bad Acads</h2>
                    </div>
                    <div class="modal-body-wrapper">

                        <div class="d-flex flex-wrap gap-3">
                            <div class="modal-text modal-right">
                                <div>
                                    <p class="f-light mb-3 text-justify">There are several preconceived notions
                                        around IIM admissions; the biggest one being that you can't get into an IIM
                                        without a stellar academic profile. But that's not the case. Targeting a
                                        good CAT percentile even with poor academics can get you into Top B-schools
                                        just like our students.</p>
                                </div>
                            </div>

                            <div class="modal-text modal-right">
                                <div class="d-flex flex-wrap gap-3">
                                    <div class="img modal-half">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/bad-1-66e91b9cbda75.webp"
                                            loading="lazy"  alt="CAT Coaching">
                                    </div>
                                    <div class="img modal-half">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/bad-2-66e91b9ca644f.webp"
                                            loading="lazy" alt="CAT Coaching">
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-lg">
    <div class="modal" id="LowPercentile" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content" *ngIf="showContent1">

                <div class="modal-body">
                    <div class="modal-header-card mb-3">
                        <h2 class="d-flex align-items-center">Low to High %le</h2>
                    </div>
                    <div class="modal-body-wrapper">

                        <div class="d-flex flex-wrap gap-3">

                            <div class="modal-text modal-right">
                                <div>
                                    <p class="f-light mb-3 text-justify">We do not just cater to the bright ones.
                                        iQuanta also has a history of getting students from a lower percentile in
                                        their previous attempts to a higher percentile.</p>
                                </div>
                            </div>

                            <div class="modal-text modal-right">
                                <div class="gallery-div d-flex flex-wrap gap-3">
                                    <div class="img d-flex flex-wrap gap-3">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-1-66e820d91185b.webp"
                                            loading="lazy" alt="CAT Coaching">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-4-66e820db57f2f.webp"
                                            loading="lazy" alt="CAT Coaching">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-7-66e820df5a172.webp"
                                            loading="lazy" alt="CAT Coaching">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-10-66e820e21937b.webp"
                                            loading="lazy"  alt="CAT Coaching">
                                    </div>
                                    <div class="img d-flex flex-wrap gap-3">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-2-66e820d93815a.webp"
                                            loading="lazy" alt="CAT Coaching">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-5-66e820dd50afe.webp"
                                            loading="lazy" alt="CAT Coaching">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-8-66e820dfdfd34.webp"
                                            loading="lazy" alt="CAT Coaching">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-11-66e820e3650db.webp"
                                            loading="lazy" alt="CAT Coaching">
                                    </div>
                                    <div class="img d-flex flex-wrap gap-3">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-3-66e820db47226.webp"
                                            loading="lazy" alt="CAT Coaching">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-6-66e820ddbad78.webp"
                                            loading="lazy" alt="CAT Coaching">
                                        <img class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/low-9-66e820e1589d9.webp"
                                            loading="lazy" alt="CAT Coaching">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-small">
    <div class="modal" id="GalleryModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">
                <div class="modal-body p-0">
                    <div class="modal-body-wrapper position-relative">
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                        <div class="d-flex gap-3">
                            <div class="modal-text modal-right">
                                <div class="d-flex gap-3 justify-content-end" style="gap: 1.4rem;">
                                    <div class="img position-relative">
                                        <img class="img-fluid"
                                            [src]="selectedImg"
                                            loading="lazy" alt="CAT Coaching">
                                            <div class="lb-nav position-absolute">
                                                <a (click)="prev()" class="lb-prev position-absolute">
                                                </a>
                                                <a (click)="next()" class="lb-next position-absolute">
                                                </a>
                                            </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-small">
    <div class="modal" id="VideoPlayer" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">
                <div class="modal-body p-0">
                    <div class="modal-body-wrapper position-relative">
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                        <div class="d-flex gap-3">
                            <div class="modal-text modal-right">
                                <div class="d-flex gap-3 justify-content-end p-4" style="gap: 1.4rem;">
                                    <!-- <video autoplay [src]="videoLink" controls name="media">
                                    </video>  -->
                                    <object class="videotab" style="width: 100%;
                                    " [data]="videoLink">
                                        <param name="movie" [value]="videoLink" />
                                        <param name="allowScriptAccess" value="always" />
                                    </object>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row main-page">
    <div class="col-md-12">
        <div class="section-header d-flex align-item-center justify-content-between mb-4">
            <h2 class="mb-md-0">iQuanta CAT Topper's Feedback</h2>
            <ng-container *ngIf="!hideButton">
            <div class="header-actions d-flex gap-2">
                <button data-toggle="modal" data-target="#ChooseEquiry"
                    class="btn d-flex align-item-center full-text">Course Enquiry
                    <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 14 14"
                            fill="none">
                            <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>
                </button>

                <button (click)="gotosection('course-comparison')"
                    class="btn d-flex align-item-center">iQuanta vs Other Coachings
                    <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 14 14"
                            fill="none">
                            <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>
                </button>

                <button data-toggle="modal" data-target="#CallsUsModal"
                    class="btn d-flex align-item-center justify-content-center icon-button p-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 26 26"
                        fill="none">
                        <path
                            d="M25.9391 19.6242C25.6362 19.3015 24.5665 18.3474 22.6002 17.0851C20.6194 15.8118 19.1586 15.0178 18.7396 14.8327C18.7027 14.8163 18.662 14.8103 18.6219 14.8153C18.5818 14.8203 18.5439 14.8361 18.5121 14.8611C17.8371 15.3875 16.7008 16.3544 16.6398 16.4066C16.2463 16.7438 16.2463 16.7438 15.9242 16.6388C15.3578 16.4531 13.5981 15.5187 12.0647 13.9819C10.5314 12.445 9.54883 10.6418 9.36311 10.076C9.2569 9.75329 9.2569 9.75329 9.59526 9.3598C9.64749 9.29886 10.615 8.1625 11.1414 7.48812C11.1663 7.45636 11.1822 7.4184 11.1872 7.37831C11.1922 7.33823 11.1862 7.29754 11.1698 7.26061C10.9847 6.84101 10.1907 5.3808 8.91738 3.4C7.65333 1.4343 6.70036 0.364677 6.37767 0.0617248C6.34806 0.0337818 6.31146 0.0143431 6.27173 0.00545689C6.23199 -0.00342928 6.1906 -0.00143382 6.15191 0.0112328C5.02394 0.398852 3.93562 0.893449 2.90182 1.48827C1.90382 2.06842 0.958986 2.73553 0.0783066 3.48183C0.0475642 3.50797 0.0245158 3.54198 0.0116332 3.58022C-0.00124946 3.61846 -0.0034803 3.65948 0.00517974 3.69889C0.126478 4.26417 0.70627 6.62395 2.50542 9.89258C4.34114 13.2285 5.61332 14.9377 8.30915 17.6242C11.005 20.3108 12.7682 21.6595 16.1076 23.4953C19.3763 25.2944 21.7372 25.8748 22.3014 25.9949C22.3409 26.0035 22.3819 26.0012 22.4203 25.9883C22.4586 25.9755 22.4927 25.9525 22.519 25.9218C23.2652 25.0411 23.9321 24.0963 24.512 23.0983C25.1067 22.0644 25.6013 20.9761 25.989 19.8482C26.0014 19.8098 26.0034 19.7688 25.9946 19.7294C25.9858 19.69 25.9667 19.6537 25.9391 19.6242Z"
                            fill="black" />
                    </svg>
                </button>
                <button (click)="joinwhatsapp()"
                    class="btn d-flex align-item-center justify-content-center icon-button icon-button-stroke p-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="#7AD06D"
                        class="bi bi-whatsapp" viewBox="0 0 16 16">
                        <path
                            d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg>
                </button>
            </div>
            </ng-container>
        </div>
    </div>
    <div class="col-md-12">
        <div class="iquanta-wrapper bg_no_mobile">
            <div class="p-0 p-sm-2">
                <div class="p-sm-3 cat-stories-mobile">

                    <h3 class="mb-3 pb-2 f-light sub_heading"><span class="f-medium">500+ CAT 99%ilers &
                            1300+ 95%ilers</span> in CAT 2024 | Record in the CAT Industry from a single
                        place!</h3>

                    <div class="d-flex gap-3">
                        <div class="cat-toppers-section mb-sm-4">

                            <div class="d-block d-sm-none">
                                <div class="d-flex stories_mobile">
                                    <div class="img" *ngFor="let slide of topperListFeedback;let i = index" (click)="openGallery(i)">
                                        <img class="img-fluid" [src]="slide" alt="topper image" loading="lazy">
                                    </div>
                                </div>

                            </div>

                            <div id="toppersHomeSlider"
                                class="carousel slide carousel-fade d-none d-sm-block" data-ride="carousel">
                                <ol class="carousel-indicators mb-0">
                                    <li data-target="#toppersHomeSlider" data-slide-to="0" class="active">
                                    </li>
                                    <li data-target="#toppersHomeSlider" data-slide-to="1"></li>
                                    <li data-target="#toppersHomeSlider" data-slide-to="2"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="d-flex flex-wrap gap-3 ">
                                            <div class="img"
                                                *ngFor="let slide of topperListFeedback.slice(0, 6);let i = index" 
                                                (click)="openGallery(i)">
                                                <img class="img-fluid" [src]="slide" alt="topper image" loading="lazy">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="d-flex flex-wrap gap-3 ">
                                            <div class="img"
                                                *ngFor="let slide of topperListFeedback.slice(6, 12);let i = index" 
                                                (click)="openGallery(i+6)">
                                                <img class="img-fluid" [src]="slide" alt="topper image" loading="lazy">
                                            </div>

                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="d-flex flex-wrap gap-3 ">
                                            <div class="img"
                                                *ngFor="let slide of topperListFeedback.slice(12, 18);let i = index" 
                                                (click)="openGallery(i+12)">
                                                <img class="img-fluid" [src]="slide" alt="topper image" loading="lazy">
                                            </div>

                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div class="toppers-feedbacks-images pl-3 d-none d-sm-block">
                            <div id="toppersFeebackSlider" class="carousel slide carousel-fade pl-1"
                                data-ride="carousel">
                                <ol class="carousel-indicators mb-0">
                                    <li data-target="#toppersFeebackSlider" data-slide-to="0"
                                        class="active"></li>
                                    <li data-target="#toppersFeebackSlider" data-slide-to="1"></li>
                                    <li data-target="#toppersFeebackSlider" data-slide-to="2"></li>
                                    <li data-target="#toppersFeebackSlider" data-slide-to="3"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="d-flex flex-column gap-3">
                                            <div class="img"
                                                *ngFor="let slide of successStories.slice(0,2)">
                                                <img class="img-fluid" [src]="slide.img" alt="topper image" loading="lazy">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="d-flex flex-column gap-3">
                                            <div class="img"
                                                *ngFor="let slide of successStories.slice(2,4)">
                                                <img class="img-fluid" [src]="slide.img" alt="topper image" loading="lazy">
                                            </div>

                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="d-flex flex-column gap-3">
                                            <div class="img"
                                                *ngFor="let slide of successStories.slice(4,6)">
                                                <img class="img-fluid" [src]="slide.img" alt="topper image" loading="lazy">
                                            </div>

                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="d-flex flex-column gap-3">
                                            <div class="img"
                                                *ngFor="let slide of successStories.slice(6,8)">
                                                <img class="img-fluid" [src]="slide.img" alt="topper image" loading="lazy">
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <div class="success-stories-feedback p-sm-4 mt-3">
                    <div class="section-header d-flex align-item-center justify-content-between mb-3 px-2">
                        <h3 class="mb-0">CAT Success Stories & Feedback</h3>

                        <div class="header-actions d-none d-sm-flex gap-2">
                            <button [routerLink]="'/iquanta-toppers-meet'"
                                class="btn d-flex align-item-center">View All Videos
                                <span
                                    class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                        viewBox="0 0 14 14" fill="none">
                                        <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                            stroke="white" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </button>


                        </div>
                    </div>

                    <div class="feedback-container d-sm-flex gap-3 px-sm-2">
                        <div class="feedback-featured-video p-1">
                            <ng-container *ngIf="!playVideoFlagStory">
                                <div class="video-img" (click)="playVideoFlagStory = !playVideoFlagStory">
                                    <img class="img-fluid"
                                        src="https://media.iquanta.in/ui_images/home-image/toppers-video-bg.webp"
                                        loading="lazy">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50"
                                        fill="currentColor"
                                        class="bi bi-play-circle-fill d-flex justify-content-center flex-column mx-auto position-absolute"
                                        viewBox="0 0 16 16">
                                        <path
                                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                    </svg>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="playVideoFlagStory">
                                <iframe loading="lazy"
                                    src="https://www.youtube.com/embed/0job0Ca6J5I?rel=0&autoplay=1&mute=1&controls=0"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen="" width="100%" height="300"></iframe>
                            </ng-container>


                        </div>

                        <div class="feedback-small-videos d-flex flex-wrap gap-3 pl-sm-2">
                            <div class="img position-relative overflow-hidden"
                                *ngFor="let slide of slider1.slice(0,6)" (click)="videoPlay(slide)">
                                <img [src]="slide.img" alt="CAT Coaching" loading="lazy">
                                <div class="caption-card position-absolute text-white px-sm-3 pt-5 pb-2">
                                    <p class="f-light">{{slide.name}}</p>
                                    <h6 class="f-bold mb-0">{{slide.percent}}</h6>
                                    <ng-container *ngIf="!hideButton">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                        fill="currentColor"
                                        class="bi bi-play-circle-fill d-flex justify-content-center flex-column mx-auto position-absolute"
                                        viewBox="0 0 16 16">
                                        <path
                                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                    </svg>
                                    </ng-container>
                                  
                                </div>
                            </div>
                        </div>

                    </div>


                    <div class="feeback-footer mt-3 px-sm-2">
                        <div class="d-flex align-item-center">
                            <div class="section-header d-none d-sm-flex align-item-center">
                                <h5 *ngIf="!hideButton" class="mb-0 f-regular">Check more feedbacks from students who had.</h5>
                                <div class="header-actions d-flex gap-3 ml-3 pt-1">
                                    <button (click)="showContent1 = true" data-toggle="modal" data-target="#LowPercentile"
                                        class="btn d-flex align-item-center">Low to High %le
                                        <span
                                            class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 14" fill="none">
                                                <path
                                                    d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                    stroke="white" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </button>

                                    <button (click)="showContent = true" data-toggle="modal" data-target="#BadAcads"
                                        class="btn d-flex align-item-center">Bad Acads
                                        <span
                                            class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 14" fill="none">
                                                <path
                                                    d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                    stroke="white" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </button>

                                </div>
                            </div>

                            <div class="ml-sm-4 d-flex align-items-center">
                                <ul class="nav results_stu_set">
                                    <li class="rounded-circle">
                                        <img class="rounded-circle img-fluid"
                                            src="https://media.iquanta.in/ui_images/kislay.webp"
                                            loading="lazy" alt="Results">
                                    </li>
                                    <li class="rounded-circle">
                                        <img class="rounded-circle img-fluid"
                                            src="https://media.iquanta.in/ui_images/Shivam-Kumar.webp"
                                            loading="lazy" alt="Results">
                                    </li>
                                    <li class="rounded-circle">
                                        <img class="rounded-circle img-fluid"
                                            src="https://media.iquanta.in/ui_images/rahul.webp"
                                            loading="lazy" alt="Results">
                                    </li>
                                    <li class="rounded-circle">
                                        <img class="rounded-circle img-fluid"
                                            src="https://media.iquanta.in/ui_images/Ankit-Raj.webp"
                                            loading="lazy" alt="Results">
                                    </li>
                                    <li class="rounded-circle">
                                        <img class="rounded-circle img-fluid"
                                            src="https://media.iquanta.in/ui_images/pratik.webp"
                                            loading="lazy" alt="Results">
                                    </li>
                                    <li class="rounded-circle d-none d-sm-block">
                                        <img class="rounded-circle img-fluid"
                                            src="https://media.iquanta.in/ui_images/Ruhi-Singh.webp"
                                            loading="lazy" alt="Results">
                                    </li>
                                    <li class="rounded-circle d-none d-sm-block">
                                        <img class="rounded-circle img-fluid"
                                            src="https://media.iquanta.in/ui_images/Rahul-Agrawal-small.webp"
                                            loading="lazy" alt="Results">
                                    </li>
                                </ul>
                                <a href="/results"
                                    class="text-uppercase f-light white-text d-flex align-items-center">Check
                                    Our Results
                                    <svg class="ml-2" xmlns="http://www.w3.org/2000/svg" width="15"
                                        height="15" viewBox="0 0 20 20" fill="none">
                                        <path
                                            d="M1.83398 10.0002H18.1673M18.1673 10.0002L10.0007 1.8335M18.1673 10.0002L10.0007 18.1668"
                                            stroke="#F9F4DD" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg></a>
                            </div>

                        </div>

                    </div>

                </div>

            </div>


        </div>
    </div>
</div>